/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Cashback Tab control actions
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { createAction } from '../../../modules/app/createAction';
import {
    CASHBACK_GET_SERVICE_LIST_FAILURE,
    CASHBACK_GET_SERVICE_LIST_START,
    CASHBACK_GET_SERVICE_LIST_SUCCESS,
    CASHBACK_RESERVE_FAILURE,
    CASHBACK_RESERVE_START,
    CASHBACK_RESERVE_SUCCESS,
    CASHBACK_TOGGLE_AUTO_SPENDING_FAILURE,
    CASHBACK_TOGGLE_AUTO_SPENDING_START,
    CASHBACK_TOGGLE_AUTO_SPENDING_SUCCESS,
} from '../pageCashbackConstants';
import {
    ICashbackReserveStartPayload,
    TCashbackGetServiceListFailureAction,
    TCashbackGetServiceListStartAction,
    TCashbackGetServiceListSuccessAction,
    TCashbackGetServiceListSuccessPayload,
    TCashbackReserveFailureAction,
    TCashbackReserveStartAction,
    TCashbackReserveSuccessAction,
    TCashbackReserveSuccessPayload,
    TCashbackToggleAutoSpendingFailureAction,
    TCashbackToggleAutoSpendingPayload,
    TCashbackToggleAutoSpendingStartAction,
    TCashbackToggleAutoSpendingSuccessAction,
} from '../types/cashbackControlTypes';

/*
* -------------------------------------------
*     Get Service list
* -------------------------------------------
*/

export const cashbackControlGetServiceListAction = (): TCashbackGetServiceListStartAction =>
    createAction(CASHBACK_GET_SERVICE_LIST_START);

export const cashbackControlGetServiceListSuccessAction = (payload: TCashbackGetServiceListSuccessPayload):
    TCashbackGetServiceListSuccessAction =>
    createAction(CASHBACK_GET_SERVICE_LIST_SUCCESS, payload);

export const cashbackControlGetServiceListFailureAction = (payload: string): TCashbackGetServiceListFailureAction =>
    createAction(CASHBACK_GET_SERVICE_LIST_FAILURE, payload);

/*
* -------------------------------------------
*     Reserve scores for the service
* -------------------------------------------
*/

export const cashbackReserveStartAction = (payload: ICashbackReserveStartPayload): TCashbackReserveStartAction =>
    createAction(CASHBACK_RESERVE_START, payload);

export const cashbackReserveSuccessAction = (payload: TCashbackReserveSuccessPayload): TCashbackReserveSuccessAction =>
    createAction(CASHBACK_RESERVE_SUCCESS, payload);

export const cashbackReserveFailureAction = (payload: string[]): TCashbackReserveFailureAction =>
    createAction(CASHBACK_RESERVE_FAILURE, payload);


/*
* -------------------------------------------
*     Toggle Auto Spending
* -------------------------------------------
*/

export const cashbackToggleAutoSpendingStartAction = (payload: TCashbackToggleAutoSpendingPayload):
    TCashbackToggleAutoSpendingStartAction => createAction(CASHBACK_TOGGLE_AUTO_SPENDING_START, payload);

export const cashbackToggleAutoSpendingSuccessAction = (payload: TCashbackToggleAutoSpendingPayload):
    TCashbackToggleAutoSpendingSuccessAction =>
    createAction(CASHBACK_TOGGLE_AUTO_SPENDING_SUCCESS, payload);

export const cashbackToggleAutoSpendingFailureAction = (payload: string): TCashbackToggleAutoSpendingFailureAction =>
    createAction(CASHBACK_TOGGLE_AUTO_SPENDING_FAILURE, payload);
